import GIF from 'gif.js';
import { lightTheme } from '../constants/themes';

// Use light theme colors as defaults for GIF export
const defaultColors = lightTheme.colors;

export const generateGIF = async ({
  width,
  height,
  columns,
  generateASCII,
  onProgress,
  onComplete,
  backgroundColor,
  foregroundColor,
  dimensionMode,
  customWidth,
  customHeight
}) => {
  const totalFrames = 30;
  const fps = 10;
  const delay = 1000 / fps;
  
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  let fontSize, charWidth, charHeight;

  if (dimensionMode === 'custom') {
    // Custom pixel mode: use exact dimensions and calculate font to fit
    canvas.width = customWidth;
    canvas.height = customHeight;

    // Calculate font size to fit the custom dimensions
    // Account for character width ratio (characters are fontSize * 0.6 wide)
    const targetFontWidth = customWidth / (width * 0.6);
    const targetFontHeight = customHeight / height;
    fontSize = Math.max(4, Math.min(20, Math.min(targetFontWidth, targetFontHeight)));
    charWidth = fontSize * 0.6;
    charHeight = fontSize;

    // Warn about large dimensions (GIFs get very large)
    if (customWidth * customHeight > 1920 * 1080) {
      console.warn('GIF export with large dimensions may result in very large file sizes');
    }
  } else {
    // Aspect ratio mode: use standard calculation
    fontSize = Math.max(4, Math.min(11, 800 / columns));
    charWidth = fontSize * 0.6;
    charHeight = fontSize;
    canvas.width = width * charWidth;
    canvas.height = height * charHeight;
  }
  
  const gif = new GIF({
    workers: 2,
    quality: 10,
    width: canvas.width,
    height: canvas.height,
    workerScript: '/gif.worker.js'
  });
  
  for (let i = 0; i < totalFrames; i++) {
    const t = (i / totalFrames) * (Math.PI * 2);
    const asciiText = generateASCII(t);
    const lines = asciiText.split('\n');
    
    ctx.fillStyle = backgroundColor || defaultColors.background;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = foregroundColor || defaultColors.foreground;
    ctx.font = `${fontSize}px monospace`;
    ctx.textBaseline = 'top';
    
    lines.forEach((line, y) => {
      [...line].forEach((char, x) => {
        ctx.fillText(char, x * charWidth, y * charHeight);
      });
    });
    
    gif.addFrame(ctx, { copy: true, delay: delay });
    
    if (onProgress) {
      onProgress({
        current: i + 1,
        total: totalFrames,
        percent: ((i + 1) / totalFrames) * 100
      });
    }
    
    await new Promise(resolve => setTimeout(resolve, 10));
  }
  
  gif.on('finished', (blob) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `significa-ascii-${Date.now()}.gif`;
    a.click();
    URL.revokeObjectURL(url);
    
    if (onComplete) {
      onComplete();
    }
  });
  
  gif.render();
};